import { useState } from 'react';
import { Image, Text, View } from 'react-native';
import { Link } from 'expo-router';
import { LinearGradient } from 'expo-linear-gradient';
import { useAuth } from '../../src/context/AuthContext';
import { useThemeMode } from '../../src/context/ThemeContext';
import { Button, ErrorText, FormInput, Label, ScreenContainer } from '../../src/components/ui';
import { InstallBanner } from '../../src/components/InstallBanner';
import { colors, fonts, gradients, radii } from '../../src/theme';
import { ApiError } from '../../src/api/client';

// Recolored per theme so the mark's own gradient matches whichever palette
// the user picked — only app.json's static "icon" (the OS home-screen icon,
// which can't be theme-aware) still points at the plain light version.
const LOGO_BY_MODE = {
  light: require('../../assets/logo-light.png'),
  dark: require('../../assets/logo-dark.png'),
  mocha: require('../../assets/logo-mocha.png'),
};

export default function LoginScreen() {
  const { login } = useAuth();
  const { mode } = useThemeMode();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const onSubmit = async () => {
    setError(null);
    setLoading(true);
    try {
      await login(email.trim().toLowerCase(), password);
    } catch (e) {
      setError(e instanceof ApiError ? e.message : 'Đăng nhập thất bại');
    } finally {
      setLoading(false);
    }
  };

  return (
    <ScreenContainer safeTop safeBottom style={{ justifyContent: 'center' }}>
      <InstallBanner />

      <View style={{ alignItems: 'center', marginBottom: 40 }}>
        <LinearGradient
          colors={gradients.hero}
          start={{ x: 0, y: 0 }}
          end={{ x: 1, y: 1 }}
          style={{
            width: 96,
            height: 96,
            borderRadius: radii.xl,
            marginBottom: 16,
            alignItems: 'center',
            justifyContent: 'center',
            shadowColor: colors.primaryDark,
            shadowOffset: { width: 0, height: 8 },
            shadowOpacity: 0.3,
            shadowRadius: 16,
            elevation: 6,
          }}
        >
          <Image
            source={LOGO_BY_MODE[mode]}
            style={{ width: 68, height: 68, borderRadius: 16 }}
          />
        </LinearGradient>
      </View>

      <Text
        style={{
          fontSize: 24,
          fontFamily: fonts.bold,
          color: colors.text,
          marginBottom: 22,
          letterSpacing: -0.4,
        }}
      >
        Đăng nhập
      </Text>

      <Label>Email</Label>
      <FormInput
        value={email}
        onChangeText={setEmail}
        autoCapitalize="none"
        keyboardType="email-address"
        placeholder="you@example.com"
      />

      <Label>Mật khẩu</Label>
      <FormInput value={password} onChangeText={setPassword} secureTextEntry placeholder="••••••••" />

      <Link
        href="/(auth)/forgot-password"
        style={{ color: colors.textMuted, fontFamily: fonts.medium, fontSize: 13, marginBottom: 4 }}
      >
        Quên mật khẩu?
      </Link>

      <ErrorText>{error}</ErrorText>

      <View style={{ marginTop: 4 }}>
        <Button title="Đăng nhập" onPress={onSubmit} loading={loading} disabled={!email || !password} />
      </View>

      <View style={{ flexDirection: 'row', justifyContent: 'center', marginTop: 22, gap: 4 }}>
        <Text style={{ color: colors.textMuted, fontFamily: fonts.regular, fontSize: 14 }}>
          Chưa có tài khoản?
        </Text>
        <Link
          href="/(auth)/register"
          style={{ color: colors.primary, fontFamily: fonts.semiBold, fontSize: 14 }}
        >
          Đăng ký
        </Link>
      </View>
    </ScreenContainer>
  );
}
